import React from "react";
import { Loader2 } from "lucide-react";

type Props = {
  ProviderIcon: React.ComponentType<{ size?: number }>;
  clickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  value: string;
  loading?: boolean;
};

export default function ProviderButton({
  ProviderIcon,
  clickHandler,
  value,
  loading = false,
}: Props) {
  return (
    <button
      onClick={clickHandler}
      disabled={loading}
      className="w-full inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-accent hover:text-accent-foreground"
      style={{
        border: '1px solid var(--color-border, #e5e7eb)',
        backgroundColor: 'var(--color-surface, #ffffff)',
        color: 'var(--color-text, #111827)',
      }}
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" style={{ color: 'var(--color-text-muted, #6b7280)' }} />
      ) : (
        <ProviderIcon size={20} />
      )}
      {value}
    </button>
  );
}
